import type { RefCallback } from "react";

// the input element serves both react-hook-form and the modal's focus-first-invalid-field registry
export const composeInputRef =
  (
    formRef: RefCallback<HTMLElement>,
    validationTargetRef?: RefCallback<HTMLElement>
  ): RefCallback<HTMLElement> =>
  (element) => {
    formRef(element);
    validationTargetRef?.(element);
  };
